import i18n from "src/i18n/config";
import { z } from "zod";

const invalidCharsRegex = /^[^+@!]*$/;

export const confirmRegistrationValidationSchema = z
    .object({
        name: z
            .string(i18n.t("common:validation.custom.nameRequired"))
            .min(1)
            .max(30)
            .regex(invalidCharsRegex, i18n.t("common:validation.noSpecialCharacters")),

        password: z
            .string(i18n.t("common:validation.custom.passwordRequired"))
            .min(8, i18n.t("common:validation.custom.passwordMin")),
        password_repeat: z.string(i18n.t("common:validation.custom.passwordRepeatRequired")),

        typeOfUsage: z.string(i18n.t("common:validation.custom.typeOfUsageRequired")),
        country: z.string(i18n.t("common:validation.custom.countryRequired")),

        privacyChecked: z
            .boolean()
            .default(false)
            .refine((val) => val === true, i18n.t("common:validation.acceptanceRequired")),

        eulaChecked: z
            .boolean()
            .default(false)
            .refine((val) => val === true, i18n.t("common:validation.acceptanceRequired")),

        newsletterChecked: z.boolean().optional(),

        companyVAT: z.string().max(30).nullable().optional(),
        companyName: z.string().max(30).nullable().optional(),
        fieldOfApplication: z.string().max(50).nullable().optional(),
    })
    .refine((data) => data.password === data.password_repeat, {
        message: i18n.t("common:validation.passwordMatch"),
        path: ["password_repeat"],
    });
